var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var { isNil } = require('lodash');

var Footer = require('../Footer/Footer');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var LoginStore = require('../../stores/LoginStore');
var AppConstants = require('../../constants/AppConstants')
var defaultMessages = require('../../i18n/messages/default');
var PageCase = require('../PageCase/PageCase.js');
var createReactClass = require('create-react-class');

var UrlUtils = require('../../utils/urlUtils.js');
var LoginBoxWrapper = require('../LoginBoxWrapper/LoginBoxWrapper.js');
var { Input, Button } = require('metro-ui-components');
var LoginHiddenFields = require('../Login/LoginHiddenFields.js');
var PasswordField = require('../Password/PasswordField.js');
var LoginHelper = require('../../utils/loginHelper.js');
var LoginHandler = require('../Login/LoginHandler.js');
var AuthMethodsHandler = require('../Login/AuthMethodsHandler.js')
var { isMobile, isTablet } = require('react-device-detect');
var ChangeLoginPreferencesComponent = require('./ChangeLoginPreferencesComponent.js');
var Utils = require('../../utils/Utils.js');
var TwoFactorAuthenticationRenderer = require('../TwoFactorAuthenticationRenderer/TwoFactorAuthenticationRenderer.js');
var ReCaptcha = require('../../utils/ReCaptcha');

var EmployeeLogin = createReactClass({
    displayName: 'EmployeeLogin',

    getInitialState() {
        return {
            allowX590Login: false,
            localeId: this.props.localeId,
            oneTimePasscode: null,
            userMFAMethods: [],
            newVpnEnabled : window.WebConstants.newVpnDetectionEnabled && window.WebConstants.newVpnDetectionEnabled.toString() === 'true' || false
        };
    },
    componentWillMount: function () {
        //check whether to display login box TOTP box
        this.showDirectTOTP(window.location.href);
    },

    
    componentDidMount: function () {
        LoginStore.addallowX509LoginListner(this.allowX590LoginCallBack);
        LoginStore.addChangeListener(this._onFooterConfigChange);
        if(this.state.newVpnEnabled){
            LoginActions.setIsIntranetRequestV2();
        }
        let appState = LoginStore.getState();
        let callAllowLoginX590 = this.state.newVpnEnabled ? appState.IsIntranetRequestV2 : this.vpnRequestDetectionV1();
        if(callAllowLoginX590) {
            LoginActions.getAllowX590Login(this.props.clientId);
        }
        
        if(false){
            let empMFAToasterMessage = this.buildMessageWithLink();
            LoginActions.triggerToast(empMFAToasterMessage,"warning");
        }

        ReCaptcha.attachRecaptchaScript(this.props.clientId, this.props.realmId);
        this.prefillLoginInput();
    },
    finalRedirectUri: '',
    showDirectTOTP(directOTPuri) {
        // In case of 2FA if the User already logged in
        // try a new page to access show OTP again
        let appState = LoginStore.getState();
        let urlIdToken = UrlUtils.getParameterByName('id_token', directOTPuri);
        let urlLoginId = UrlUtils.getParameterByName('login_id', directOTPuri);
        let urlCode = UrlUtils.getParameterByName('code', directOTPuri);
        let urlRedirectUri = UrlUtils.getParameterByName('redirect_uri', directOTPuri);
        this.finalRedirectUri = urlRedirectUri ? urlRedirectUri.concat("#code=").concat(urlCode).concat("&id_token=").concat(urlIdToken) : '';
        let urlParsed_token = Utils.tryParseToken(urlIdToken);

        const authMethod = LoginHelper.getAuthMethod(urlParsed_token);
        if (urlParsed_token && authMethod) {
            LoginActions.getUserMFAMethods(urlIdToken, this.props.countryCode);
            this.setState({
                showTOTPControl: authMethod,
                loginId: urlLoginId,
                phone: urlParsed_token.phone,
                emailId: urlParsed_token.email,
                idToken: urlIdToken,
                userId: urlParsed_token.sub,
                userMFAMethods: appState.userMFAMethods,
                authMethodDeviceName: !isNil(appState.userMFAMethods) && appState.userMFAMethods.length > 0 ? LoginHelper.setAuthenticationMethod(appState.userMFAMethods).name : '',
                credentialId: !isNil(appState.userMFAMethods) && appState.userMFAMethods.length > 0 ? LoginHelper.setAuthenticationMethod(appState.userMFAMethods).credentialId : ''
            });
        }
    },

    vpnRequestDetectionV1(){
        let isInternalRequest = window.WebConstants && window.WebConstants.requestType == AppConstants.INTRANET_REQUEST;
        let isExternalRequest = window.WebConstants &&  window.WebConstants.requestType == AppConstants.EXTERNAL_REQUEST;

        return (isInternalRequest || isExternalRequest);
    },

    _onFooterConfigChange: function () {
        const { forceEmployee2FA } = window.WebConstants;
        if(this.state.newVpnEnabled){
            LoginActions.setIsIntranetRequestV2();
        }
        let appState = LoginStore.getState();

        let showLoginAsEmployeeLinkInInternet = appState.showLoginAsEmployeeLinkInInternet
            ? appState.showLoginAsEmployeeLinkInInternet.toString() === 'true' : false

        let showLoginAsCustomerLink = appState.showLoginAsCustomerLink
            ? appState.showLoginAsCustomerLink.toString() === 'true' : false

        let employeeLoginRequiresOTP = forceEmployee2FA ? forceEmployee2FA.toString() === 'true' : false;
        let isInternetDetection = this.state.newVpnEnabled ? !appState.IsIntranetRequestV2 : (window.WebConstants.requestType == AppConstants.INTERNET_REQUEST);
        
        if(!employeeLoginRequiresOTP) {
            employeeLoginRequiresOTP = appState.employeeLoginRequiresOTP && !UrlUtils.isSamlFlow() &&
            isInternetDetection ? appState.employeeLoginRequiresOTP.toString() === 'true' : false
        }

        this.setState({
            showLoginAsCustomerLink: showLoginAsCustomerLink,
            showLoginAsEmployeeLinkInInternet: showLoginAsEmployeeLinkInInternet,
            employeeLoginRequiresOTP: employeeLoginRequiresOTP,
            forgotPwdLinkUrl: appState.forgotPwdLinkUrl
        });
    },

    allowX590LoginCallBack: function () {
        const appState = LoginStore.getState();
        this.setState({ allowX590Login: appState.allowX509Login })
    },

    renderFooter: function () {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <Footer {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
                </div>
            </IntlProvider>
        )
    },

    onLogin(evt) {
        const { loginId, password, oneTimePasscode, localeId } = this.state;
        evt.preventDefault();

        if (!(loginId && password)) {
            return;
        }

        if (UrlUtils.isSamlFlow()) {
            LoginActions.submitSamlLogin(loginId, password, this.props.userType, this.props.clientId, this.props.countryCode, localeId, this.props.realmId, this.props.traceId);
        } else {
            if (this.state.employeeLoginRequiresOTP) {
                LoginActions.submitLoginWithPasscode(loginId, password, oneTimePasscode, this.props.userType, this.props.clientId, this.props.responseType, this.props.countryCode, localeId, this.props.realmId, this.props.accountId, this.props.redirectUrl, this.props.state, this.props.nonce, this.props.scope, this.props.traceId, this.props.codeChallenge, this.props.codeChallengeMethod);
            } else {
                ReCaptcha.getRecaptchaToken((token) =>
                    LoginActions.submitLogin(loginId, password, this.props.userType,
                        this.props.clientId, this.props.responseType, this.props.countryCode, localeId,
                        this.props.realmId, this.props.accountId, this.props.redirectUrl, this.props.state, this.props.prompt, this.props.nonce,
                        this.props.scope, this.props.traceId, this.props.codeChallenge, this.props.codeChallengeMethod, token)
                );
            }
        }
    },

    prefillLoginInput() {
        const { loginId } = this.props;
        loginId ? this.setState({ loginId }) : null
    },

    onLoginIdChange(value) {
        this.setState({ loginId: value });
    },

    onOneTimePasscodeChange(value) {
        this.setState({ oneTimePasscode: value });
    },

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    },

    onPasswordChange(password) {
        this.setState({ password: password });
    },

    renderLoginLink() {
        if (this.state.showLoginAsCustomerLink) {
            let props = this.props;
            var url = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId + UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) + UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, AppConstants.UserTypes.CUST) + UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) + UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) + UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, this.state.localeId) + UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) + UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) + UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) + UrlUtils.appendQueryParam(AppConstants.UrlParams.PROMPT, props.prompt) + UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) + UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state) + UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, props.codeChallenge) + UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod) + UrlUtils.appendQueryParam(AppConstants.UrlParams.PREVIEW, this.props.preview) + UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, this.props.traceId);
            const loginAsCustomer = this.props.intl.formatMessage(defaultMessages['loginAsCustomer']);
            return (
                <div>
                    <span className="pull-right-lg pull-right-md">
                        <a href={url} className="blue-labels">
                            {loginAsCustomer}
                        </a>
                    </span>
                </div>
            )
        }
    },

    renderTwoFactorAuthenticationComponent() {
        return (
            <TwoFactorAuthenticationRenderer
                {... this.props}
                phone={this.state.phone}
                emailId={this.state.emailId}
                login={this.state.loginId}
                idToken={this.state.idToken}
                userId={this.state.userId}
                credentialId={this.state.credentialId}
                authMethodDeviceName={this.state.authMethodDeviceName}
                directOtpRedirectUri={this.finalRedirectUri}
                twoFaAuthMethod={this.state.showTOTPControl}
                userMFAMethods={this.state.userMFAMethods}
                showTryOtherLink={this.state.userMFAMethods ? this.state.userMFAMethods.length > 1 : false}
            />
        );
    },

    requestAuthWIthCertificate() {
        var props = this.props;
        var host = window.location.host.indexOf('localhost') != -1 ? 'localhost:9001' : window.location.host;

        if (UrlUtils.isSamlFlow()) {
            window.location.href = window.location.protocol + "//" + host + "/saml/realm/" + props.realmId + "/client/" +
                props.clientId + "/user/" + props.userType + "/auth?" + AppConstants.UrlParams.SAML_AUTHENTICATION_CERTIFICATE + "=" + true
        }
        else {
            window.location.href = window.location.protocol + "//" + host + AppConstants.Links.AUTHORIZE_URL + "?" +
                AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, this.state.localeId) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.PROMPT, props.prompt) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, props.codeChallenge) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
                UrlUtils.appendQueryParam(AppConstants.UrlParams.AUTHENTICATION_CERTIFICATE, true)
        }
    },

    setLoginState(value) {
        this.setState(value)
    },

    renderLogin() {
        var props = this.props;
        const label = this.props.intl.formatMessage(defaultMessages['userName']);
        const linkText = props.intl.formatMessage(defaultMessages['login.link.WithCertificate']);
        const loginButtonText = this.props.intl.formatMessage(defaultMessages['loginBtnTxt']);

        return (
            <LoginBoxWrapper>
                <div>
                    <form id="authForm" noValidate="novalidate" onSubmit={this.onLogin} autoComplete="off" >
                        <Input
                            id="user_id"
                            type="email"
                            key="user_id"
                            name="user_id"
                            autoComplete="off"
                            label={label}
                            required={true}
                            hasWarning={this.state.loginError ? true : false}
                            defaultValue={this.props.loginId || ""}
                            onChange={(_, value) => { this.onLoginIdChange(value) }}
                            onKeyUp={(_, value) => { this.onLoginIdChange(value) }}
                            onKeyDown={(_, value) => { this.onLoginIdChange(value) }}
                            autoFocus={true}
                            link={this.state.allowX590Login ? linkText : null}
                            onLinkClick={() => { this.requestAuthWIthCertificate() }}
                        />
                        <PasswordField
                            {... this.props}
                            onPasswordChange={this.onPasswordChange} />
                        {this.state.employeeLoginRequiresOTP ? <Input
                            id="otp"
                            type="text"
                            key="otp"
                            name="otp"
                            autoComplete="off"
                            label={this.props.intl.formatMessage(defaultMessages['enter_totp'])}
                            required={true}
                            value={this.state.oneTimePasscode}
                            onChange={(_, value) => { this.onOneTimePasscodeChange(value) }}
                            onKeyUp={(_, value) => { this.onOneTimePasscodeChange(value) }}
                            onKeyDown={(_, value) => { this.onOneTimePasscodeChange(value) }}
                        /> : null}
                        <LoginHiddenFields {... this.props} />
                        {this.state.employeeLoginRequiresOTP ? <Button
                            id="submit"
                            type="submit"
                            value="submit"
                            kind="primaryRaised"
                            size="large"
                            className="primary-button"
                            disabled={!(this.state.loginId && this.state.password && this.state.oneTimePasscode)}>
                            {loginButtonText}
                        </Button> : <Button
                            id="submit"
                            type="submit"
                            value="submit"
                            kind="primaryRaised"
                            size="large"
                            className="primary-button"
                            disabled={!(this.state.loginId && this.state.password)}>
                                {loginButtonText}
                            </Button>}
                    </form>
                    <div className="row">
                        <div className="forgotPasswordLink">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div>
                                    {this.state.forgotPwdLinkUrl &&
                                        <a href={this.state.forgotPwdLinkUrl} className="deep-blue-labels">
                                            {this.props.intl.formatMessage(defaultMessages['forgotPassword'])}
                                        </a>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                {this.renderLoginLink()}
                            </div>
                        </div>
                    </div>
                </div>
            </LoginBoxWrapper>
        );

    },

    buildMessageWithLink() {
        let employeeMFAMessage = this.props.intl.formatMessage(defaultMessages['employeeMFAChange']);

        const regex = /(\[.*?\])/g;
        const parts = employeeMFAMessage.split(regex);
        
        const finalArray = [];
    
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].startsWith('[') && parts[i].endsWith(']')) {
                const regex2 = /\[(.*?)\|(.*?)\]/g;
                const [_, text, link] = regex2.exec(parts[i]);
                finalArray.push({ text, link }); 
            } else if (parts[i] !== '') { 
                finalArray.push(parts[i]);
            } 
        }

        const textBuilder = finalArray.map((item, index) => {
            if (typeof item === "object") {
                return(
                    <>
                        <a className="toaster-link" onClick={(e)=>{
                            e.stopPropagation()
                            window.open(`${item.link}`, '_blank')
                        }}>
                            {item.text}
                        </a>
                    </>
                )}
            else {
                return (<>{item}</>)
                }
            });

        return (
            <div className="toaster-link-container">
                <p className='toaster-text'>{textBuilder}</p>
            </div>
        )
    },

    renderContent: function () {
        let renderedComponent = !this.state.employeeLoginRequiresOTP ? this.renderOnlyLoginContent() :
            this.renderLoginWithChangeLoginPreferencesContent();
        return (
            <div>
                {renderedComponent}
            </div>
        )
    },

    renderOnlyLoginContent: function () {
        let props = this.props;
        let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
        let headerMessage = LoginHelper.getloginHeader(props);
        let renderedComponent = this.state.showTOTPControl ? this.renderTwoFactorAuthenticationComponent() : this.renderLogin();

        return (
            <div className="portraitCenteredEmployee">
                <div className="welcomeTitle">
                    <span id="welcomeToMetroDigital">
                        {bodyHeader}
                    </span>
                </div>
                <div className="employeeBoxContainer container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{headerMessage}</span>
                                        </ div>
                                    </div>
                                </div>
                                {renderedComponent}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
                <LoginHandler {...props}  loginId={this.state.loginId} localeId={this.state.localeId} userMFAMethods={this.state.userMFAMethods} setState={(value) => { this.setLoginState(value) }} />
                <AuthMethodsHandler {...props} setState={(value) => { this.setLoginState(value) }} />
            </div>
        );
    },

    renderLoginWithChangeLoginPreferencesContent() {
        let props = this.props;
        let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
        let headerMessage = LoginHelper.getloginHeader(props);
        let renderedComponent = this.state.showTOTPControl ? this.renderTwoFactorAuthenticationComponent() : this.renderLogin();
        return (
            <div className="portraitCenteredCustomer">
                <div className="customerBodyWrapper">
                    <div className="welcomeTitleCustomer">
                        <span id="welcomeToMetroDigital">
                            {bodyHeader}
                        </span>
                    </div>
                    <div className="customerBodyBoxes">
                        <div className="col-lg-2 col-md-1 col-sm-12 col-xs-12"></div>
                        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 custWrapper">
                            <div className="row whiteContainer">
                                <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 customerLoginWrapper">
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="form-group centreAligned loginHeader">
                                                        <span>{headerMessage}</span>
                                                    </ div>
                                                </div>
                                            </div>
                                            {renderedComponent}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="seperator"></div>
                                    <ChangeLoginPreferencesComponent />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-1 col-sm-12 col-xs-12"></div>
                    </div>
                </div>
                <LoginHandler {...props} loginId={this.state.loginId} localeId={this.state.localeId} setState={(value) => { this.setLoginState(value) }} />
                <AuthMethodsHandler {...props} setState={(value) => { this.setLoginState(value) }} />
            </div>
        )
    },

    render: function () {
        return (
            <PageCase
                header={<Header />}
                content={this.renderContent()}
                footer={this.renderFooter()}></PageCase>
        );
    }
});

module.exports = injectIntl(EmployeeLogin);
